import React from 'react';
import { IWarehouseShelf } from '../../../../interfaces/delivery-company/warehouseshelf';
import { Dialog, DialogContent } from '@mui/material';
import CreateShelfForm from '../shelf-form/create-shelf-form';
import CustomDialog from '../../../common/custom-dialog/custom-dialog';

interface EditShelfDialogProps {
    shelf: IWarehouseShelf
    onClose: () => void
}
function EditShelfDialog({ shelf, onClose }: EditShelfDialogProps) {
    return (
        <CustomDialog open={true} onClose={onClose} fullWidth>
            < DialogContent >
                <CreateShelfForm defaultShelf={shelf} />
            </DialogContent >
        </CustomDialog>
    );
}

export default EditShelfDialog;